var map = {
	"./img_1.png": 36437,
	"./img_2.jpg": 57421,
	"./img_3.jpg": 47766,
	"./img_4.jpg": 11288,
	"./img_5.png": 74831,
	"./img_6.jpg": 60441,
	"./img_7.png": 68413
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 580;